import React from 'react'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import IconSkipPrevious from '@material-ui/icons/SkipPrevious'
import IconPrevious from '@material-ui/icons/KeyboardArrowLeft'
import IconNext from '@material-ui/icons/KeyboardArrowRight'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import Button from './Button'


const styles = theme => ({
  root: {
    padding: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  leftIcon: {
    marginLeft: 10,
  },
  text: {
    marginLeft: 10,
    marginRight: 10,
    display: 'inline-block',
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
})


const Pagination = ({
  limit,
  page,
  count,
  onNext,
  onFirst,
  hasMore,
  classes,
  onExport,
  isLoading,
  onPrevious,
  hasPrevious,
}) => {
  const offset = page * limit
  let current = Math.floor(offset / limit)
  let total = Math.max(0, Math.floor((count - 1) / limit))

  if (isNaN(current)) {
    current = 0
  }

  if (isNaN(total)) {
    total = 0
  }

  return (
    <Grid
      container
      className={classes.root}
    >
      <Button
        color="secondary"
        onClick={onFirst}
        isLoading={isLoading}
        disabled={!hasPrevious}
      >
        <IconSkipPrevious className={classes.leftIcon} />
        Première page
      </Button>

      <Grid container alignItems="center" justify="center" className="flex1">
        <Button
          isLoading={isLoading}
          color="secondary"
          disabled={!hasPrevious}
          onClick={onPrevious}
        >
          <IconPrevious className={classes.leftIcon} />
          Page précédente
        </Button>

        <Typography className={classes.text}>&nbsp;</Typography>

        <Button
          color="primary"
          onClick={onNext}
          disabled={!hasMore}
          isLoading={isLoading}
        >
          <IconNext className={classes.leftIcon} />
          Page suivante
        </Button>
      </Grid>

      <Button onClick={onExport}><CloudDownloadIcon /></Button>
    </Grid>
  )
}


Pagination.defaultProps = {
  page: 0,
  count: 0,
  limit: 25,
}


Pagination.propTypes = {
  onNext: PropTypes.func,
  page: PropTypes.number,
  onFirst: PropTypes.func,
  hasMore: PropTypes.bool,
  limit: PropTypes.number,
  count: PropTypes.number,
  onExport: PropTypes.func,
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  classes: PropTypes.object,
  onPrevious: PropTypes.func,
  hasPrevious: PropTypes.bool,
}


export default withStyles(styles)(Pagination)
